import { Component, Inject, OnInit, Optional } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { CrudService } from "src/app/services/crud.service";
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: "app-questionnaire-details",
  templateUrl: "./questionnaire-details.component.html",
  styleUrls: ["./questionnaire-details.component.css"],
})
export class QuestionnaireDetailsComponent implements OnInit {
  spinner: boolean = false;
  videoId: any;
  limit: number = 3;
  page: number = 1;
  questionnaireId: any;
  questionnaireDetails: any[] = [];
  totalSubmittedQuestionnaires: any;
  //WC 05112025 --- groupId
  groupId: any;
  mainVideoDetail: any;
  mainVideoId: any;
  //WC 051525 --- group detail
  groupDetail: any;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private crudService: CrudService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) @Optional() public data: any,
  ) {
    if(this.data && this.data.videoId) {
      this.videoId = this.data?.videoId
      this.questionnaireId = this.data?.questionnaireId
      this.groupId = this.data?.groupId
    } else {
      this.videoId = this.activatedRoute.snapshot.queryParamMap.get("videoId");
      this.questionnaireId =
        this.activatedRoute.snapshot.queryParamMap.get("questionnaireId");
      this.groupId =
        this.activatedRoute.snapshot.queryParamMap.get("groupId");
    }

    //console.log("in QuestionnaireDetailsComponent.constructor - this.groupId", this.groupId);
  }

    ngOnInit(): void {
  
      this.spinner = true;
      
      if (this.groupId)
        this.getGroupInfo();

      this.getMainVideoInfo();
      this.getQuestionnaireResultDetails(this.page, this.limit);
      this.getNoOfSubmittedQuestionnaires()
    }

    onScrollTab(): void {
      ++this.page;
      this.getQuestionnaireResultDetails(this.page, this.limit)
    }

    getGroupInfo(){
      this.spinner = true
      this.crudService.getGroupDetail(this.groupId).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
        this.groupDetail = res.data[0];
      })
  
    }

    getMainVideoInfo() {
      
      this.spinner = true;

      this.crudService.getVideoInfov2(this.videoId).subscribe((res) => {
        this.mainVideoDetail = res.data?.videoinfo;

        //WC 051425  ---- To be passed to the Dashboard link
        if (this.mainVideoDetail.type == "main")
          this.mainVideoId = this.mainVideoDetail._id;
        else
          this.mainVideoId = this.mainVideoDetail.mainId;
      });

      this.spinner = false;
    }

    getQuestionnaireResultDetails(page:number, limit:number) {

      this.spinner = true

      let data = {
        videoId : this.videoId,
        questionnaireId: this.questionnaireId,
        page,
        limit
      };

      //WC 05112025 --- groupId
      if(this.groupId) 
        data['groupId'] = this.groupId;
      //console.log("in QuestionnaireDetailsComponent.getQuestionnaireResultDetails - data", data);

      this.crudService
        .getQuestionnaireResultDetails(data)
        .subscribe((res: any) => {
          this.questionnaireDetails = [...this.questionnaireDetails, ...res.data];
          this.spinner = false;
        });
    }

    getNoOfSubmittedQuestionnaires() {

      this.spinner = true

      let data = {
        videoId : this.videoId,
        questionnaireId: this.questionnaireId
      };

      if (this.groupId) 
        data['groupId'] = this.groupId;

      this.crudService
        .getNoOfSubmittedQuestionnaires(data)
        .subscribe((res: any) => {
          this.totalSubmittedQuestionnaires = res.data.noOfSubmittedQuestionnaires
          this.spinner = false;
        });

      this.spinner = false
    };

    
}
